module.exports = __webpack_public_path__ + "static/img/10.ce707b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/10.png
// module id = dU+5
// module chunks = 4